<template>
  <path
    d="M12 2.00024C6.5 2.00024 2 6.50024 2 12.0002C2 17.5002 6.5 22.0002 12 22.0002C17.5 22.0002 22 17.5002 22 12.0002C22 6.50024 17.5 2.00024 12 2.00024ZM4 12.0002C4 7.60024 7.6 4.00024 12 4.00024C13.8 4.00024 15.5 4.60024 16.9 5.70024L5.7 16.9002C4.6 15.5002 4 13.8002 4 12.0002ZM12 20.0002C10.2 20.0002 8.5 19.4002 7.1 18.3002L18.3 7.10024C19.4 8.50024 20 10.2002 20 12.0002C20 16.4002 16.4 20.0002 12 20.0002Z"
  />
</template>
